<template>
  <modal name="menuListFilterModal">
    <menu-filter />
  </modal>
</template>


<script>
  import MenuFilter from './menu-filter/index.vue';

  export default {
    name: 'MenuFilterModal',

    components: {
      MenuFilter
    }
  };
</script>
